import Message from '@admin/components/message'
import Icon from '@admin/components/icon'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import React from 'react'

class Single extends React.Component {

  static propTypes = {
    files: PropTypes.array,
    onBack: PropTypes.func
  }

  render() {
    return (
      <div className="maha-attachments-single">
        <Message { ...this._getMessage() } />
      </div>
    )
  }

  _getMessage() {
    const file = this.props.files[0]
    const progress = numeral(file.progress).format('0%')
    return {
      ...file?.create?.body?.url ? {
        preview: file.create.body.url
      } : file?.thumbnail ? {
        preview: file?.thumbnail
      } : {
        icon: this._getIcon(file.content_type)
      },
      title: file.name,
      component: (
        <div className="maha-attachments-single-progress">
          <div className="maha-filefield-progress">
            <div className="ui green tiny progress">
              <div className="bar" style={{ width: progress }} />
            </div>
          </div>
          { file.progress < 1 ?
            <div className="maha-attachments-single-text">
              <T text="t(Uploading)" />
            </div> :
            <div className="maha-attachments-single-text">
              <Icon icon="spin fa-circle-o-notch" /> <T text="t(Processing)" />
            </div>
          }
        </div>
      )
    }
  }

  _getIcon(content_type) {
    if(content_type.match(/image/)) return 'file-image-o'
    if(content_type.match(/drawing/)) return 'file-image-o'
    if(content_type.match(/audio/)) return 'file-audio-o'
    if(content_type.match(/video/)) return 'file-video-o'
    if(content_type.match(/pdf/)) return 'file-pdf-o'
    if(content_type.match(/excel/)) return 'file-excel-o'
    if(content_type.match(/spreadsheet/)) return 'file-excel-o'
    if(content_type.match(/msword/)) return 'file-word-o'
    if(content_type.match(/powerpoint/)) return 'file-powerpoint-o'
    if(content_type.match(/presentation/)) return 'file-powerpoint-o'
    if(content_type.match(/wordprocessing/)) return 'file-word-o'
    if(content_type.match(/document/)) return 'file-word-o'
    if(content_type.match(/map/)) return 'map-o'
    if(content_type.match(/zip/)) return 'file-archive-o'
    if(content_type.match(/xml/)) return 'file-code-o'
    if(content_type.match(/html/)) return 'file-code-o'
    return 'file-text-o'
  }

}

export default Single
